import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';
import {
  RankingComprasDetalheResponse,
  RankingComprasResponse,
} from './ranking-compras';

@Injectable()
export class RankingComprasService extends ServiceCRUD {
  private readonly tipoOperacao = '5';
  private baseUrlService: string;

  constructor(
    public httpClient: HttpClient,
    router: Router,
    protected toastr: ToastrService
  ) {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return `${this.baseUrlService}/ranking_compras`;
  }

  public getRanking(
    data_inicial: string,
    data_final: string,
    userDealerIds: string,
    dealer?: string,
    limite?: number
  ): Observable<RankingComprasResponse> {
    let params = new HttpParams()
      .set('data_inicial', data_inicial)
      .set('data_final', data_final)
      .set('tipo_operacao', this.tipoOperacao);

    if (dealer) {
      params = params.set('dealer', dealer);
    }

    if (limite) {
      params = params.set('limite', String(limite));
    }

    return this.httpClient.get<RankingComprasResponse>(
      `${this.baseUrlService}/ranking_compras`,
      {
        headers: this.buildHeaders(userDealerIds),
        params,
      }
    );
  }

  public getDetalhe(
    data_inicial: string,
    data_final: string,
    userDealerIds: string,
    dealer?: string,
    codigo_cliente?: string,
    sem_cliente?: string
  ): Observable<RankingComprasDetalheResponse> {
    let params = new HttpParams()
      .set('data_inicial', data_inicial)
      .set('data_final', data_final)
      .set('tipo_operacao', this.tipoOperacao);

    if (dealer) {
      params = params.set('dealer', dealer);
    }

    if (sem_cliente) {
      params = params.set('sem_cliente', sem_cliente);
    } else if (codigo_cliente) {
      params = params.set('codigo_cliente', codigo_cliente);
    }

    return this.httpClient.get<RankingComprasDetalheResponse>(
      `${this.baseUrlService}/ranking_compras/detalhe`,
      {
        headers: this.buildHeaders(userDealerIds),
        params,
      }
    );
  }

  private buildHeaders(userDealerIds: string): HttpHeaders {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      Authorization: JSON.parse(sessionStorage.getItem('currentUser')).token,
    };

    if (userDealerIds) {
      headers['x-user-dealer'] = userDealerIds;
    }

    return new HttpHeaders(headers);
  }
}
